interface AvatarProps {
  width?: number;
  height?: number;
  url: string;
}

const Avatar: React.FC<AvatarProps> = ({ width, height, url }) => (
  <img src={url} className="aspect-square h-full rounded-full shrink-0 grow-0" height={height} width={width} />
);

export { Avatar };
